

































import { Vue, Component } from 'vue-property-decorator';
import { Tab, Tabs, Popup, Icon, Divider } from 'vant';
import * as config from './config';
import { getVoteList } from '@/api/api';
import VoteButton from './VoteButton.vue';
Vue.use(Popup)
  .use(Tab)
  .use(Tabs)
  .use(Icon)
  .use(Divider);
@Component({
  components: {
    VoteButton,
  },
})
export default class First extends Vue {
  option = config.OPTHINES;
  tabData = ['智能手机', '网络出行', '电商购物', '智慧家庭'];
  listData = [];
  active = 0;
  // get NewListData() {
  //   return this.listData;
  // }
  // set NewListData(val: any) {
  //   console.log(val);
  // }
  async created() {
    const res = await getVoteList({
      voteName: this.option.voteName,
      type: this.active + 1,
    });
    this.listData = res.data;
  }
  async onClick() {
    const res = await getVoteList({
      voteName: this.option.voteName,
      type: this.active + 1,
    });
    this.listData = res.data;
  }
  votSuccess(e: number) {
    (this.listData[e] as any).votes =
      Number((this.listData[e] as any).votes) + 1;
  }
}
